<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">全部订单</h1>-->
    <!--</header>-->
    <nav class="mui-bar mui-bar-tab" style="padding: 0px;">
      <button class="mui-btn-blue btn-blue filter-btn" @click="filter()">
        <span class="mui-icon iconfont icon-filter" style="vertical-align: middle;"></span>
        <span style="vertical-align: middle;">筛选</span>
      </button>
    </nav>
    <div class="mui-content pd-8" style="bottom: 50px;">
      <div class="title-name" style="margin-bottom: 15px;">
         <span class="">全部坯布卷</span>
      </div>
      <!-- 坯布卷一览 -->
      <div class="flex-content" v-for="(item,i) in infoLst" style="margin-top: 10px;">
        <div class="flex-box" style="padding-right: 2px;">
          <div class="flex-container">
            <div class="flex-container flex-2 flex-vertical">
              <div class="flex-content-container">
                <div class="flex-content-label">TSD卷号:</div>
                <div class="flex-content-span flex-1">{{item.tsdrollno}}</div>
              </div>
              <div class="flex-content-container">
                <div class="flex-content-label">外注卷号:</div>
                <div class="flex-content-span flex-1" style="word-wrap:break-word; word-break:normal;">{{item.wzrollno}}</div>
              </div>
              <div class="flex-content-container">
                <div class="flex-content-label">所属订单:</div>
                <div class="flex-content-span flex-1">{{item.ddh}}</div>
              </div>
              <div class="flex-content-container">
                <div class="flex-content-label" >长度:</div>
                <div v-if="item.ddqf=='1' || item.ddqf=='3'" class="flex-content-span flex-1">
                  {{item.boltnum}}匹/{{item.length}}m
                </div>
                <div v-else class="flex-content-span flex-1">
                  {{item.boltnum}}匹/{{item.netweight}}kg  
                </div>
              </div>
            </div>
            <div class="flex-container flex-1 flex-vertical">
              <div class="flex-content-container" style="display: block;">
                <div class="flex-content-span flex-1">No:{{i+1}}</div>
              </div>
              <div class="flex-content-container" style="align-items: center">
                <div class="flex-content-span flex-1" >
                  <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="handlePrint(item)" >打印标签</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打印设备选择弹出框 -->
    <div v-if="printBoxVisible" class="mui-popup mui-popup-in" style="display: block;">
      <div class="mui-popup-inner">
        <div class="mui-popup-title">打印标签</div>
        <div class="mui-popup-text">
          <div class="form-group" style="margin: 15px 0 0 5px">  
            <div class="input-label">   <label>标签设备:</label> </div>
            <div class="form-input" style="text-align: left">   
              <select v-model="device">  
                <option v-for="item in deviceLst" :value="item">{{item.f_dvname}}</option>   
              </select> 
            </div>
          </div>
        </div>
        <div class="mui-popup-buttons">
          <span class="mui-popup-button" @click="printZJBQ">确认</span>
          <span class="mui-popup-button" @click="printBoxVisible=false">取消</span><!--device=null; -->
        </div>
      </div>
    </div>
    <div v-if="printBoxVisible" class="mui-popup-backdrop mui-active" style="display: block;"></div>
  </section>
</template>
<script>
export default {
  name: "labelOrders",
  data() {
    return {
      searchifo: {
        ksbh: '',   // 供应商编号
        wph: '',    // 物料代码
        ddh: '',    // 订单号
        wzrollno: '',   // 外注卷号
        tsdrollno: '',  // TSD卷号 
      },
      infoLst: [],    // 坯布卷列表
      rollInfo: null, // 当前坯布卷
      deviceLst: [],  // 标签打印设备列表
      device: null,   // 当前选择的标签打印设备
      printBoxVisible: false // 是否显示打印标签弹出框
    }
  },
  created() {
  },
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.searchifo.ksbh = para.ksbh;
      v.searchifo.wph = para.wph;
      v.searchifo.ddh = para.ddh;
      v.searchifo.wzrollno = para.wzrollno;
      v.searchifo.tsdrollno = para.tsdrollno;
      v.query();
    }
  },
  methods: {
    filter() {
      this.$router.go(-1);
    },
    // 查询筛选条件的坯布卷
    query() {
      var v = this;
      v.nyy.doPost("/quality/getClothRolls", v.searchifo,
        function(result) {
          if (result.status) {
            v.infoLst = result.data.infoLst;
            v.deviceLst = result.data.deviceLst;
            if(v.deviceLst && v.deviceLst.length >0){
              v.device = v.deviceLst[0];
            }
          }
        }
      );
    },
    contractState(zt) {
      const states = ['', '加工中', '物料完成', '终止']; 
      return states[zt];
    },
    handlePrint(currRoll) {
      this.rollInfo = currRoll;
      this.printBoxVisible = true;
    },
    // 为当前坯布卷补打标签
    printZJBQ() {
      var v = this;
      var jdetail;  // 卷详情
      var postMap;  // post数据

      if (v.rollInfo.ddqf == "2") {
        // 编织标签打印
        // 针织布的规格：幅宽+幅宽单位 * 幅长+幅长单位 (编成长 + 编成长单位)
        var bcc = ((v.rollInfo.bcc == "") ? "0" : v.rollInfo.bcc);
        var length = (parseFloat(v.rollInfo.boltnum) * parseFloat(bcc)).toFixed(1);
        
        postMap = {
          "tsdrollno": v.rollInfo.tsdrollno,  // TSD卷号
          "clothcode": v.rollInfo.clothcode,  // 坯布品番 (坯布质检 - 坯布品番 )
          "breadth": v.rollInfo.breadth,      // ERP-幅宽（单位CM）
          "gauge_length": v.rollInfo.gauge_length, // ERP-公称幅长（单位M）
          "length": length,   // 布长
          "boltnum": v.rollInfo.boltnum,      // 匹数
          "netweight": v.rollInfo.netweight,  // 重量
          "bdoresult": v.rollInfo.boresult,   // 色区分 (悬念反处置结果 关联取样单号可以获取;若没有，固定值“无”)
          "fname": v.rollInfo.fname,          // 织布工厂 (供应商-简称 表中数据对应简称2)
          "wzrollno": v.rollInfo.wzrollno,    // 外注卷号
          "fallingtime": v.rollInfo.fallingtime,  // 落布时间(yyyy年mm月dd日)
          "clothremakflg": "",                // 坯布区分 机织的情况下使用
          "remark": v.rollInfo.remark,        // 备 注
          "ddqf": "2", // 订单区分
          "dvno": v.device.dvno,    // 终端编号
          "fkdw": v.rollInfo.fkdw,  // 幅宽单位
          "fcdw": v.rollInfo.fcdw,  // 幅长单位
          "bcc": v.rollInfo.bcc,    // 编成长
          "bccdw": v.rollInfo.bccdw // 编成长单位
        }
      } else {
        // 机织、AB坯布卷标签打印（C级不打吊牌）
        if (v.grade == "C") {
          mui.toast("C级不打吊牌！")
        } else {
          postMap = {
            "tsdrollno": v.rollInfo.tsdrollno,  // TSD卷号
            "clothcode": v.rollInfo.clothcode,  // 坯布品番 (坯布质检 - 坯布品番 )
            "wzrollno": v.rollInfo.wzrollno,    // 外注卷号
            "clothremakflg": v.rollInfo.ddqf == "1" ? v.rollInfo.clothremakflg : "", // 坯布区分 机织的情况下使用
            "rollernumber": v.rollInfo.rollernumber,    // 轴  号
            "boltnum": v.rollInfo.boltnum,      // 匹数
            "length": v.rollInfo.length,        // 布长
            "machineno": v.rollInfo.machineno, // 织机号
            "grade": (v.rollInfo.grade == 'B' ? '悬念反' : v.rollInfo.grade), // 等  级 (A、C、悬念反)
            "fallingtime": v.rollInfo.fallingtime, // 落布时间(yyyy年mm月dd日)
            "fname": v.rollInfo.fname,      // 织布工厂 (供应商-简称 表中数据对应简称2)todo
            "bdoresult": v.rollInfo.bdoresult,      // 色 区 分 (悬念反处置结果;若没有，固定值“无”)
            "remark": v.rollInfo.remark,    // 备    注
            "ddqf": v.rollInfo.ddqf,        // 订单区分
            "dvno": v.device.dvno           // 终端编号
          };
        }
      }

      // 发送打印数据，准备打印标签
      if (postMap) {
        v.nyy.doPost("/Quality/printZJBQ", postMap,
          function(result) {
            v.printBoxVisible = false;
          }
        );
      }

      // 重置当前选择的坯布卷及打印设备
      v.rollInfo = null;
      // v.device = null;
    }
  }
}
</script>
<style scoped>
@import "../../static/css/filterorder.css";

.flex-vertical {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/labelOrders.vue